import React, { useEffect, useMemo, useState } from 'react';
import { get } from 'lodash';
import {
  dashboardsSelector,
  tempKeysSelector,
  afterInitializationSelector,
} from '@store/tempDashboard/selectors';
import { useDispatch, useSelector } from 'react-redux';
import { PageNotFound } from '@components/common';
import * as tempDashboardActions from '@store/tempDashboard/actions';

// TODO: also support updating LS based on state changes
function TempDashboardHoc({ match, applyCallback, initStore, children }) {
  const dispatch = useDispatch();
  const localStorageInit = useSelector(afterInitializationSelector);
  const [ready, setReady] = useState(false);
  const dashboards = useSelector(dashboardsSelector);
  const dashboardKeys = useSelector(tempKeysSelector);
  const tempDashboardId = `${get(match, 'params.id', -1)}`;

  // load temp dashboard data from LS
  useEffect(() => {
    if (!localStorageInit) {
      dispatch(tempDashboardActions.init());
    }
  }, [dispatch, localStorageInit]);

  // selected dashboard config
  const dashboardConfig = useMemo(() => {
    return dashboards[tempDashboardId];
  }, [dashboards, tempDashboardId]);

  // saga actions
  useEffect(() => {
    if (dashboardConfig) {
      applyCallback(dashboardConfig, () => setReady(true));
    }
  }, [applyCallback, dashboardConfig]);

  // intialize jotai store with default state
  const store = useMemo(() => {
    if (dashboardConfig) {
      return initStore(dashboardConfig);
    }
    return null;
  }, [dashboardConfig, initStore]);

  if (!dashboardKeys.includes(tempDashboardId)) {
    return <PageNotFound />;
  }

  return ready ? children({ store }) : <>Loading...</>;
}

export default TempDashboardHoc;
